import {useForm} from "react-hook-form";
import React, {useContext, useEffect, useState} from "react";
import {Paper} from "@mui/material";
import strings from "../../../localization";
import DrawerContext from "../../../Context/DrawerContext";
import LinearProgress from '@mui/material/LinearProgress';
import SnackbarContext from "../../../Context/SnackbarContext";
import CompositeProductForm from "../../../Components/Forms/Pages/Product/CompositeProductForm";
import {getProductServiceList} from "../../../Services/Product/ProductServiceService";
import {editCompositeProduct} from "../../../Services/Product/CompositeProductService";


const formRules = {
    'quantity': {required: true},
    'product': {required: true},
}

const EditCompositeProduct = (props) => {

    const {setDrawerTitle} = useContext(DrawerContext);
    const { showMessage } = useContext(SnackbarContext);
    const form = useForm({
        defaultValues: props.data && props.data.length > 0 ? props.data[0] : undefined
    });
    const {data, control, handleSubmit, getValues, setValue, formState: {errors}} = form;
    const [showLoader, setShowLoader] = useState(false);
    const [products, setProducts] = useState(0);


    useEffect(() => {
        setDrawerTitle(strings.pages.product.compositeProduct.editCompositeProductList.pageTitle);
    });

    useEffect(()=>{
        fetchProducts();
    },[])

    const fetchProducts = (term = "") => {
        getProductServiceList({term}).then((response) => {
            if (!response || !response.ok) {
                return;
            }
            setProducts(response.data.result.filter(r => r && r.id != props.productId));
        });
    }

    const onSubmit = (data) => {

        setShowLoader(true);

        editCompositeProduct(data).then(response => {
            setShowLoader(false);

            if (!response || !response.ok) {
                showMessage(strings.commonMessages.errorEditing, 'error');
                props.onFinish();
                return;
            }

            showMessage(strings.commonMessages.editingSuccessful, 'success');
            props.onFinish();
        });
    }

    const onCancel = () => {
        props.onCancel();
    }

    return <div className='drawer-form'>
        <Paper className='paper'>
            {
                showLoader &&
                <LinearProgress/>
            }
            <CompositeProductForm
                formRules={formRules}
                values={getValues()}
                setValue={setValue}
                onProductChangeFilter={fetchProducts}
                products={products}
                errors={errors} data={data} form={form} control={control}
                onSubmit={handleSubmit(onSubmit)} onCancel={() => onCancel()}/>
        </Paper>
    </div>
}

export default EditCompositeProduct;